<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" :disabled="Boolean(role.admin_id)" />

        <action-button type="delete" @click="del(role.id)" v-if="role.id && $can('role-delete')" :disabled="Boolean(role.admin_id)" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="role.name"
                  v-model="role.name"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('roles.name')"
                  :error-messages="errors.collect('role.name')"
                  :readonly="Boolean(role.admin_id)"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="role.slug"
                  v-model="role.slug"
                  :label="$t('roles.slug')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <div v-if="role.id">
          <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
            <page-header-title :title="$t('roles.permission_btn')"></page-header-title>
          </v-app-bar>

          <v-expansion-panels class="mb-3 elevation-0" :value="Number(!expand)" v-for="item in all_permissions" :key="item.id">
            <v-expansion-panel>
              <v-expansion-panel-header class="transparent pl-2">
                <template v-slot:actions>
                  <v-icon class="expandable-icon mr-3">$expand</v-icon>
                </template>
                <span class="expandable-header">{{ $dd_modules(item.module) }}</span>
                <div class="expandable-action text-right">
                  (<v-btn text @click.native.stop @click="autoselect('check', item.module)">{{ $t("roles.check_all") }}</v-btn>
                  |
                  <v-btn text @click.native.stop @click="autoselect('uncheck', item.module)">{{ $t("roles.uncheck_all") }}</v-btn
                  >)
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container grid-list-md class="pa-0 ma-0">
                  <v-layout row wrap>
                    <v-flex v-for="data in item.permissions" :key="data.id" class="perm-row" xs12 md6>
                      <input
                        v-model="checked"
                        type="checkbox"
                        name="chk_permission"
                        :value="data.name"
                        :checked="checked.includes(data.name)"
                        :disabled="Boolean(role.admin_id)"
                      />
                      {{ data.name }}
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "RoleForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      predata: {},
      role: {},

      permissions: [],
      all_permissions: [],
      checked: [],

      expand: true,

      dictionary: {
        attributes: {
          "role.name": this.$t("roles.name"),
          "role.slug": this.$t("roles.slug")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.role, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  watch: {
    role: {
      handler(val) {
        if (!this.role.id) {
          let name = this.role.name ? this.role.name : ""
          this.role.slug = this.$slug(name)
        }
      },
      deep: true
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.page_title = this.$t("roles.new_role")

      this.role = {}

      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.role))

      this.getPermissions()
    } else {
      this.title = this.$t("roles.update_title")

      axios
        .get(this.API_URL + "role/" + this.id)
        .then((res) => {
          this.role = res.data.data

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.role))

          this.page_title = this.$t("roles.edit_role", { name: this.role.name })

          this.getPermissions()
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    getPermissions() {
      let vm = this

      vm.permissions = vm.role.permissions

      axios
        .get(vm.API_URL + "permissions?show_all=true")
        .then((res) => {
          let _permissions = res.data.data
          let _all_permissions = []

          // save all the permissions to "all_permissions" variable and group it by module
          for (let _module of vm.$dd_modules()) {
            _all_permissions.push({
              module: _module.key,
              permissions: _permissions.filter((_permission) => _permission.module === _module.key)
            })
          }

          vm.all_permissions = _all_permissions

          // set checked permission
          if (vm.permissions.length > 0) {
            vm.permissions.forEach(function (value) {
              vm.checked.push(value.name)
            })
          }
        })
        .catch((err) => console.log(err))
    },
    autoselect(type, mod = null) {
      if (Boolean(this.role.admin_id)) return

      let permissions = this.all_permissions.filter((i) => i.module == mod)[0].permissions.map((i) => i.name)

      if (type == "check") {
        this.checked.push(...permissions)
      } else {
        this.checked = this.checked.filter((item) => !permissions.includes(item))
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.role.id) {
              // Create
              axios
                .post(this.API_URL + "role", {
                  name: this.role.name,
                  slug: this.role.slug
                })
                .then((res) => {
                  if (res.data.data.id) {
                    vm.role = res.data.data
                    vm.predata = JSON.parse(JSON.stringify(vm.role))

                    vm.savePermissions()
                    vm.page_title = vm.$t("roles.edit_role", { name: vm.role.name })
                    vm.$awn.success(vm.$t("global.create_success"))
                    vm.$router.replace(this.BACKEND_URL + `/roles/edit/${vm.role.id}`).catch(() => {})
                  }
                })
                .catch((err) => {
                  return false
                })
            } else {
              // Update
              axios
                .put(this.API_URL + "role", {
                  id: this.role.id,
                  name: this.role.name,
                  slug: this.role.slug
                })
                .then((res) => {
                  vm.role = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.role))

                  vm.savePermissions()

                  vm.page_title = vm.$t("roles.edit_role", { name: vm.role.name })
                  vm.$store.dispatch("auth/updateUserState", vm)
                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    savePermissions() {
      let vm = this

      axios
        .post(this.API_URL + "role/permissions", {
          id: vm.role.id,
          permissions: vm.checked
        })
        .then((res) => {
          let data = res.data.data

          if (data.id) {
            vm.$store.dispatch("auth/updateUserState", vm)
          }
        })
        .catch((err) => console.log(err))
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "role/" + id)
            .then((res) => {
              vm.$store.dispatch("auth/updateUserState", vm)
              vm.$router.push(this.BACKEND_URL + "/roles")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style>
.expandable-icon {
  order: 0;
}

.expandable-header {
  order: 1;
  color: rgba(0, 0, 0, 0.87) !important;
  opacity: 0.85;
}

.expandable-action {
  order: 2;
  color: rgba(0, 0, 0, 0.87) !important;
  opacity: 0.85;
}
</style>
